import { unaryStreamRpc } from "@redotech/rpc/definition";
import * as z from "zod";

const MessageSchema_ = z.object({
  role: z.enum(["user", "assistant"]),
  content: z.string(),
});

const TextDeltaEvent_ = z.object({
  type: z.literal("text-delta"),
  textDelta: z.string(),
});

const ToolCallEvent_ = z.object({
  type: z.literal("tool-call"),
  toolCallId: z.string(),
  toolName: z.string(),
  input: z.unknown(),
});

const StatusEvent_ = z.object({
  type: z.literal("status"),
  status: z.string(),
});

const IterationCompleteEvent_ = z.object({
  type: z.literal("iteration-complete"),
  pendingToolsCount: z.number(),
});

const ThreadIdEvent_ = z.object({
  type: z.literal("thread-id"),
  threadId: z.string(),
});

const CompleteEvent_ = z.object({
  type: z.literal("complete"),
  threadId: z.string(),
});

const ErrorEvent_ = z.object({ type: z.literal("error"), message: z.string() });

const SuggestionsEvent_ = z.object({
  type: z.literal("suggestions"),
  suggestions: z.array(z.string()),
});

export const AeoAssistantStreamEventSchema = z.discriminatedUnion("type", [
  TextDeltaEvent_,
  ToolCallEvent_,
  StatusEvent_,
  IterationCompleteEvent_,
  ThreadIdEvent_,
  CompleteEvent_,
  ErrorEvent_,
  SuggestionsEvent_,
]);
export type AeoAssistantStreamEvent = z.infer<
  typeof AeoAssistantStreamEventSchema
>;

export const streamAeoAssistant = unaryStreamRpc({
  name: "streamAeoAssistant" as const,
  input: z.object({
    threadId: z.string().optional(),
    messages: z.array(MessageSchema_),
  }),
  output: AeoAssistantStreamEventSchema,
});
